'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _shopifySectionsManager = require('shopify-sections-manager');

var _shopifySectionsManager2 = _interopRequireDefault(_shopifySectionsManager);

require('intersection-observer');

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

var _DynamicCollection = require('../sections/DynamicCollection');

var _DynamicCollection2 = _interopRequireDefault(_DynamicCollection);

var _DynamicDrawer = require('../sections/DynamicDrawer');

var _DynamicDrawer2 = _interopRequireDefault(_DynamicDrawer);

var _DynamicLogoList = require('../sections/DynamicLogoList');

var _DynamicLogoList2 = _interopRequireDefault(_DynamicLogoList);

var _DynamicLogoCarousel = require('../sections/DynamicLogoCarousel');

var _DynamicLogoCarousel2 = _interopRequireDefault(_DynamicLogoCarousel);

var _DynamicSlideshow = require('../sections/DynamicSlideshow2');

var _DynamicSlideshow2 = _interopRequireDefault(_DynamicSlideshow);

var _DynamicQuoteSlider = require('../sections/DynamicQuoteSlider');

var _DynamicQuoteSlider2 = _interopRequireDefault(_DynamicQuoteSlider);

var _DynamicCollectionToggle = require('../sections/DynamicCollectionToggle');

var _DynamicCollectionToggle2 = _interopRequireDefault(_DynamicCollectionToggle);

var _DynamicFeatureBlocks = require('../sections/DynamicFeatureBlocks');

var _DynamicFeatureBlocks2 = _interopRequireDefault(_DynamicFeatureBlocks);

require('../../styles/templates/index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndexPage = function IndexPage() {
  (0, _classCallCheck3.default)(this, IndexPage);

  var sections = window.shopifySections || new _shopifySectionsManager2.default();

  sections.register('dynamic-collection', function (section) {
    return new _DynamicCollection2.default(section);
  });
  sections.register('dynamic-drawer', function (section) {
    return new _DynamicDrawer2.default(section);
  });
  sections.register('logo-list', function (section) {
    return new _DynamicLogoList2.default(section);
  });
  sections.register('dynamic-logo-carousel', function (section) {
    return new _DynamicLogoCarousel2.default(section);
  });
  sections.register('gallery', function (section) {
    return new _DynamicLogoList2.default(section);
  });
  sections.register('dynamic-slideshow', function (section) {
    return new _DynamicSlideshow2.default(section);
  });
  sections.register('dynamic-quote-slider', function (section) {
    return new _DynamicQuoteSlider2.default(section);
  });
  sections.register('dynamic-collection-toggle', function (section) {
    return new _DynamicCollectionToggle2.default(section);
  });
  sections.register('dynamic-feature-blocks', function (section) {
    return new _DynamicFeatureBlocks2.default(section);
  });

  _rimgShopify2.default.init();
};

exports.default = IndexPage;


new IndexPage();